<template>
  <v-card flat class="ma-n2 pa-0 air-quality-popup">
    <v-btn id="popupPanelCloseButton" text class="popup-panel-close-button d-sm-none">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
    <v-container fluid pa-0 pa-4>
      <v-row class="ma-0 pa-0">
        <v-col cols="12" sm="12" md="12" class="ma-0 pa-0">
          <strong>{{ sensordata.name }}</strong>
        </v-col>
      </v-row>
      <v-row class="ma-0 pa-0">
        <v-col
          cols="12"
          sm="12"
          md="12"
          class="ma-0 pa-0"
        >{{ new Date(sensordata.lastupdatedatetime).toLocaleString() }}</v-col>
      </v-row>
      <v-row class="ma-0 pa-0 mt-2">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon>mdi-home</v-icon>
        </v-col>
        <v-col cols="10" sm="10" md="10" class="ma-0 pa-0">{{ sensordata.description }}</v-col>
      </v-row>
      <v-row class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon v-bind:style="{ color: markerColor10 }">mdi-weather-windy</v-icon>
        </v-col>
        <v-col
          cols="10"
          sm="10"
          md="10"
          class="ma-0 pa-0"
        >pm10: {{ sensordata.pm10.toFixed(1) }} &#181;g/m&#179;</v-col>
      </v-row>
      <v-row class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon v-bind:style="{ color: markerColor25 }">mdi-weather-windy</v-icon>
        </v-col>
        <v-col
          cols="10"
          sm="10"
          md="10"
          class="ma-0 pa-0"
        >pm2.5: {{ sensordata.pm25.toFixed(1) }} &#181;g/m&#179;</v-col>
      </v-row>
      <v-row v-if="sensordata.predictionPM10 !== undefined" class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon v-bind:style="{ color: predictionMarkerColor10 }">mdi-weather-windy</v-icon>
        </v-col>
        <v-col
          cols="10"
          sm="10"
          md="10"
          class="ma-0 pa-0"
        >pm10 za <strong>{{ sensordata.predictionHour }}h</strong>: {{ sensordata.predictionPM10.toFixed(1) }} &#181;g/m&#179;</v-col>
      </v-row>
      <v-row v-if="sensordata.predictionPM25 !== undefined" class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon v-bind:style="{ color: predictionMarkerColor25 }">mdi-weather-windy</v-icon>
        </v-col>
        <v-col
          cols="10"
          sm="10"
          md="10"
          class="ma-0 pa-0"
        >pm2.5 za <strong>{{ sensordata.predictionHour }}h</strong>: {{ sensordata.predictionPM25.toFixed(1) }} &#181;g/m&#179;</v-col>
      </v-row>
      <v-row class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon>mdi-thermometer-lines</v-icon>
        </v-col>
        <v-col
          cols="10"
          sm="10"
          md="10"
          class="ma-0 pa-0"
        >Temperatura {{ sensordata.temperature.toFixed(0) }}&deg;C</v-col>
      </v-row>
      <v-row class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon>mdi-weather-rainy</v-icon>
        </v-col>
        <v-col
          cols="10"
          sm="10"
          md="10"
          class="ma-0 pa-0"
        >Wilgotność {{ sensordata.humidity.toFixed(0) }}%</v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn @click="close" text>Zamknij</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import SensorLimits from "../tools/SensorLimits";
export default {
  name: "AirQualityPopupVue",
  data() {
    return {};
  },
  props: {
    sensordata: { type: Object }
  },
  methods: {
    close() {
      document.querySelector(".leaflet-popup-close-button").click();
    }
  },
  computed: {
    markerColor25: function() {
      let markerColor = "#58b109";
      if (this.sensordata) {
        let pm25 = this.sensordata.pm25;
        markerColor = SensorLimits.getLimitColor("PM25", pm25);
      }
      return markerColor;
    },
    markerColor10: function() {
      let markerColor = "#58b109";
      if (this.sensordata) {
        let pm10 = this.sensordata.pm10;
        markerColor = SensorLimits.getLimitColor("PM10", pm10);
      }
      return markerColor;
    },
    predictionMarkerColor25: function() {
      let markerColor = "#58b109";
      if (this.sensordata) {
        let pm25 = this.sensordata["pm25h" + this.sensordata.predictionHour]
        markerColor = SensorLimits.getLimitColor("PM25", pm25);
      }
      return markerColor;
    },
    predictionMarkerColor10: function() {
      let markerColor = "#58b109";
      if (this.sensordata) {
        let pm10 = this.sensordata["pm10h" + this.sensordata.predictionHour]
        markerColor = SensorLimits.getLimitColor("PM10", pm10);
      }
      return markerColor;
    }
  }
};
</script>
<style>
@media (min-width: 480px) {
  .air-quality-popup {
    width: 100%;
    margin: 0px;
  }
}

.leaflet-popup-close-button {
  background-color: #e60085 !important;
  color: #ffffff !important;
  position: fixed !important;
  right: 0px !important;
  min-width: 0px !important;
  width: 30px !important;
  height: 30px !important;
  border-radius: 0px !important;
  margin-right: 9px !important;
  margin-top: 15px !important;
  padding: 8px 0px 0px 0px !important;
  font-weight: normal !important;
}

.popup-panel-close-button {
  background-color: #e60085 !important;
  color: #ffffff !important;
  position: fixed !important;
  padding: 0px !important;
  right: 0px !important;
  min-width: 0px !important;
  width: 30px !important;
  height: 30px !important;
  border-radius: 0px !important;
  margin-right: 9px !important;
  margin-top: 15px !important;
}
</style>